import { FC, PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { AppBarHeadingContext } from './AppBarHeadingContext';
import { AppBarHeadingContextType } from './types';

export const AppBarHeadingProvider: FC<PropsWithChildren> = ({ children }) => {
  const [headingStack, setHeadingStack] = useState<string[]>([]);

  const registerHeading = useCallback((newHeading: string) => {
    setHeadingStack((prev) => [...prev, newHeading]);
    return () => setHeadingStack((prev) => prev.slice(0, -1));
  }, []);

  const value = useMemo<AppBarHeadingContextType>(
    () => ({
      heading: headingStack.at(-1) ?? '',
      registerHeading,
    }),
    [headingStack, registerHeading]
  );

  return <AppBarHeadingContext value={value}>{children}</AppBarHeadingContext>;
};
